import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SlideshowModule',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      active: state => state.sclSlideshowModule.active,
      values: state => state.sclSlideshowModule.values,
      isModify: state => state.sclSlideshowModule.isModify
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // input
    posX: {
      get () {
        return this.values.posX
      },
      set (value) {
        this.setInputValue({
          keys: ['posX'],
          value: value
        })
      }
    },
    posY: {
      get () {
        return this.values.posY
      },
      set (value) {
        this.setInputValue({
          keys: ['posY'],
          value: value
        })
      }
    },
    width: {
      get () {
        return this.values.width
      },
      set (value) {
        this.setInputValue({
          keys: ['width'],
          value: value
        })
      }
    },
    height: {
      get () {
        return this.values.height
      },
      set (value) {
        this.setInputValue({
          keys: ['height'],
          value: value
        })
      }
    },

    // validate
    disablePostButton () {
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclSlideshowModule/hide',
      reset: 'sclSlideshowModule/reset',
      setLayer: 'screenConfigLayout/setLayer',
      removeLayer: 'screenConfigLayout/removeLayer'
    }),
    ...mapMutations({
      setInputValue: 'sclSlideshowModule/setInputValue'
    }),

    init () {
      // this.loading = true
    },

    /**
     * レイヤー情報を設定
     */
    postData () {
      this.setLayer(this.values)
      this.hide()
    },
    /**
     * レイヤー情報を削除
     */
    removeData () {
      this.removeLayer(this.values)
      this.hide()
    },

    /**
     * テキストエリアでEnterキー押下の処理
     */
    onKeydownEnter(keyCode) {
      if (keyCode !== 13) return
      this.postData()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}